// extracted by mini-css-extract-plugin
export var currencyInput = "_oz-1";
export var currencySymbol = "_oz-0";